<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-1">
    <div class="header" i18n>Enter Verification Code</div>
    <div class="subtext">{{ subText$ | async }}</div>
  </div>

  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'timeBasedOneTimePassword'" i18n>Verification Code</label>
      <app-text-input
        #textInput
        formControlName="timeBasedOneTimePassword"
        controlId="timeBasedOneTimePassword"
        [error]="formSubmitted && formGroup.controls.timeBasedOneTimePassword.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.timeBasedOneTimePassword.invalid"
        [errors]="formGroup.controls.timeBasedOneTimePassword.errors"
        [customErrorMessages]="customErrorMessages.timeBasedOneTimePassword" />
    </div>
  </div>

  <app-button class="w-100" i18n [type]="ButtonTypeEnum.primary" (buttonClick)="verifyMfa()">
    Verify Account
  </app-button>
</div>
